import React from "react";
import { SmallText, XsmallText } from "../../lib/ui/components/typography/Typography";

export const QUESTION_GENERATION_TYPE = {
    KNOCKOUT_ONLY: "knockout_only",
    KNOCKOUT_PLUS_EVALUATION: "knockout_plus_evaluation",
};

export default function GenerateQuestionsModal({ value, onChange }) {
    const tiles = [
        {
            id: QUESTION_GENERATION_TYPE.KNOCKOUT_PLUS_EVALUATION,
            label: "Knockout + evaluation questions",
            description:
                "Up to two knockout questions for the dealbreakers you've stated, plus scored questions about real situations candidates have handled in this kind of work.",
        },
        {
            id: QUESTION_GENERATION_TYPE.KNOCKOUT_ONLY,
            label: "Knockout questions only",
            description:
                "Pass/Fail screening questions, only for requirements you've stated for this role, such as location, schedule, pay, work authorization, or required licenses.",
        },
    ];

    return (
        <div className="space-y-4">
            <SmallText className="m-0">
                Choose how deep the AI should go based on your job description.
            </SmallText>
            <div className="grid gap-3">
                {tiles.map((tile) => {
                    const selected = value === tile.id;
                    return (
                        <label
                            key={tile.id}
                            className={[
                                "flex cursor-pointer flex-col gap-2 rounded-lg border p-4 text-left transition-colors",
                                selected
                                    ? "border-primary bg-purple-50/80 ring-1 ring-primary"
                                    : "border-gray-200 bg-white hover:border-gray-300",
                            ].join(" ")}
                            data-cy={`generate-questions-type-${tile.id}`}
                        >
                            <div className="flex items-start gap-3">
                                <input
                                    type="radio"
                                    name="questionGenerationType"
                                    value={tile.id}
                                    checked={selected}
                                    onChange={() => onChange(tile.id)}
                                    className="mt-1 h-4 w-4 shrink-0 border-gray-300 text-primary focus:ring-primary"
                                />
                                <div className="min-w-0">
                                    <SmallText emphasis={true} weight="semibold">
                                        {tile.label}
                                    </SmallText>
                                    <XsmallText>{tile.description}</XsmallText>
                                </div>
                            </div>
                        </label>
                    );
                })}
            </div>
        </div>
    );
}
